import styled from "styled-components";

export default styled.div`
&{
  width: 100%;
  height: 100%;
}


.fileContract {
  display:flex;
  justify-content: space-around;
  align-items: center;
  div  {
    display:flex;
    flex-direction:column;
    align-items: center;
  }
}

.downloadButton{
  svg {
    color: ${props => props.theme.colors.black};
    margin: 0;
  }
  padding: 10px 15px 10px 15px;
}
`